import jQuery from "jquery";
// CRITICAL: Set window.jQuery BEFORE importing Bootstrap so its UMD wrapper
// can find jQuery on the global when registering $.fn.dropdown etc.
window.jQuery = jQuery;
window.$ = jQuery;

// Side-effect imports. Bootstrap's UMD wrapper registers jQuery plugins
// when this module evaluates. We force it by referencing each plugin so
// the bundler keeps the side effects.
import * as AlertMod from "bootstrap/js/dist/alert";
import * as ButtonMod from "bootstrap/js/dist/button";
import * as CarouselMod from "bootstrap/js/dist/carousel";
import * as CollapseMod from "bootstrap/js/dist/collapse";
import * as DropdownMod from "bootstrap/js/dist/dropdown";
import * as ModalMod from "bootstrap/js/dist/modal";
import * as PopoverMod from "bootstrap/js/dist/popover";
import * as ScrollspyMod from "bootstrap/js/dist/scrollspy";
import * as TabMod from "bootstrap/js/dist/tab";
import * as ToastMod from "bootstrap/js/dist/toast";
import * as TooltipMod from "bootstrap/js/dist/tooltip";
import * as UtilMod from "bootstrap/js/dist/util";

// Reference the modules so esbuild cannot tree-shake them away.
const Alert = AlertMod.default;
const Button = ButtonMod.default;
const Carousel = CarouselMod.default;
const Collapse = CollapseMod.default;
const Dropdown = DropdownMod.default;
const Modal = ModalMod.default;
const Popover = PopoverMod.default;
const Scrollspy = ScrollspyMod.default;
const Tab = TabMod.default;
const Toast = ToastMod.default;
const Tooltip = TooltipMod.default;
const Util = UtilMod.default;

// Defensive: if any Bootstrap plugin is not registered on jQuery after the
// imports, register it manually using the imported constructor class via
// Bootstrap's _jQueryInterface. Bootstrap classes expose a static
// _jQueryInterface method that handles `this` argument properly.
function ensurePlugin(name, Class) {
	if (window.jQuery && window.jQuery.fn) {
		const fn = window.jQuery.fn[name];
		if (typeof fn !== "function" && Class && Class._jQueryInterface) {
			window.jQuery.fn[name] = Class._jQueryInterface;
			window.jQuery.fn[name].Constructor = Class;
		}
	}
}
ensurePlugin("alert", Alert);
ensurePlugin("button", Button);
ensurePlugin("carousel", Carousel);
ensurePlugin("collapse", Collapse);
ensurePlugin("dropdown", Dropdown);
ensurePlugin("modal", Modal);
ensurePlugin("popover", Popover);
ensurePlugin("scrollspy", Scrollspy);
ensurePlugin("tab", Tab);
ensurePlugin("toast", Toast);
ensurePlugin("tooltip", Tooltip);

export {
	Util,
	Alert,
	Button,
	Carousel,
	Collapse,
	Dropdown,
	Modal,
	Popover,
	Scrollspy,
	Tab,
	Toast,
	Tooltip,
};
